import {Component, OnInit} from "@angular/core";
import * as _ from "lodash";
import {PortableDevice} from "../json/portable-device";
import {PortableRegistrationService} from "../services/portable-registration.service";

@Component({
	selector: "portable-registration-portables-table",
	template: `
		<!---------- CUSTOMER'S REGISTERED PORTABLE DEVICES ---------->
		<div *ngIf="portables && portables.length > 0">

			<!---------- HEADING ---------->
			<h2>Your Registered Portable Devices</h2>

			<!---------- DESCRIPTION ---------->
			<p>
				Note: The following table contains all Garmin devices that you have registered, including non-aviation devices.
			</p>

			<!---------- TABLE OF PORTABLES ---------->
			<div class="warrantyregistration_portables">
				<table class="warrantyregistration_portables_table">
					<tr>
						<th>Product Name</th>
						<th>Serial Number</th>
						<th>Part Number</th>
						<th>Unit ID</th>
						<th>Source</th>
					</tr>
					<tr *ngFor="let portable of portables">
						<td>{{portable.productName}}</td>
						<td>{{portable.serialNumber}}</td>
						<td>{{portable.partNumber}}</td>
						<td>{{portable.unitId}}</td>
						<td>{{portable.source}}</td>
					</tr>
				</table>
			</div>
		</div>

		<!---------- LOADING SPINNER ---------->
		<fly-loading [message]="'Loading your registered portable devices...'" *ngIf="isLoading"></fly-loading>
	`,
})
export class PortableRegistrationPortablesTableComponent implements OnInit {
	portables: Array<PortableDevice>;
	isLoading = false;

	constructor(private portableRegistrationService: PortableRegistrationService) {}

	ngOnInit() {
		this.refreshPortables();
	}

	refreshPortables() {
		this.isLoading = true;
		this.portables = null;
		this.portableRegistrationService.getRegisteredPortableDevices().subscribe(portables => {
			this.portables = _.sortByOrder(portables,
				[portable => portable.productName, portable => portable.serialNumber],
				["asc", "asc"]);
			this.isLoading = false;
		}, () => {
			this.isLoading = false;
		});
	}
}
